import React from 'react';

const CircleLines = () => {
    return (
        <div className='header__circle-lines'>
            <div className='header__circle-lines_line'></div>
            <div className='header__circle-lines_line'></div>
            <div className='header__circle-lines_line'></div>
            <div className='header__circle-lines_line'></div>
            <div className='header__circle-lines_line'></div>
            </div>
    );
};

export default CircleLines;